export default __webpack_public_path__ + "static/media/registered_autonomy.f50ab115.svg";